import { render, staticRenderFns } from "./index.vue?vue&type=template&id=449bc31b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=449bc31b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.15_css-loader@6.11.0_webpack@5.99.9__lodash@4._8e7d9d8dfed228e26c1c84bf99921c8c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bc31b",
  null
  
)

export default component.exports